// Intent: [Journey] [SEO/GEO] [Trust]
import React from "react";
import { ButtonLink } from "../components/shared/ButtonLink";
import { PageHero } from "../components/shared/PageHero";
import { TutorialLibrary } from "../components/shared/TutorialLibrary";
import type { Tutorial } from "../components/shared/TutorialLibrary";
const tutorials: readonly Tutorial[] = [{
  id: "xjqY_iHaREQ",
  title: "Assemble a Base Cabinet",
  description: "Assembly steps for a standard base cabinet."
}, {
  id: "YbFVdDsJGwQ",
  title: "Assemble an Upper Cabinet",
  description: "Assembly steps for an overhead cabinet."
}, {
  id: "q8I6_eJ6nag",
  title: "Assemble an L-Corner",
  description: "Assembly guidance for an L-shaped corner cabinet."
}, {
  id: "-8yWJ4biizc",
  title: "Assemble a Tall Cabinet",
  description: "Join and assemble a two-part tall cabinet."
}, {
  id: "rtzLMJyM8wY",
  title: "Assemble an Oven Cabinet",
  description: "Assembly steps for an under-bench oven cabinet."
}, {
  id: "7A9fuEexV1g",
  title: "Install Adjustable Feet",
  description: "Fit adjustable feet to the cabinet."
}, {
  id: "zRyKhJ9dyBc",
  title: "Install Hinge Plates",
  description: "Position and install cabinet hinge plates."
}, {
  id: "TQ32AccH0tw",
  title: "Install Cabinet Doors",
  description: "Mount and adjust standard cabinet doors."
}, {
  id: "vfZR4Zce0SU",
  title: "Install Bi-Fold Doors",
  description: "Install bi-fold doors on the cabinet."
}, {
  id: "pFDAliT1lws",
  title: "Install Drawer Runners",
  description: "Position and install drawer runners."
}, {
  id: "8paCUKR0VwE",
  title: "Assemble a Drawer Box",
  description: "Build the internal drawer box."
}, {
  id: "8pfZe_UVDT8",
  title: "Install Drawer Fronts",
  description: "Install and align standard drawer fronts."
}, {
  id: "bCQTveyKz8w",
  title: "Premium Drawer Fronts",
  description: "Install the relevant premium drawer front."
}];
function AssemblyGuidePage() {
  return <main id="main-content" data-id="element-260" data-mp="3rlgdpw5uaz1n">
      <PageHero eyebrow="Video guide" title="Assemble and install your cabinets." copy="Choose a cabinet or component to watch the relevant step-by-step guide." data-id="element-261" data-mp="3rm84mtohs8ll">
        <ButtonLink href="/help/" data-id="element-262" data-mp="javwzfqvcvxl">Get Help Finding a Guide</ButtonLink>
      </PageHero>
      <section className="section-shell bg-[#eceae4]" data-id="element-263" data-mp="5jpqgzp69y17"><div className="container-shell" data-id="element-264" data-mp="5ksjbd622ajr"><TutorialLibrary tutorials={tutorials} label="Assembly tutorial" data-id="element-265" data-mp="5hmqpny7wqja" /></div></section>
      <section className="bg-pfpc-navy py-9 text-pfpc-offwhite" data-id="element-266" data-mp="aj2cji87z12q"><div className="container-shell flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-267" data-mp="y8535fku049d"><div data-id="element-268" data-mp="12a9ug7nt4osu"><h2 className="font-heading text-[26px] font-extrabold" data-id="element-269" data-mp="12a9wed7dayvh">Need help identifying a component?</h2><p className="mt-2 text-[14px] text-pfpc-offwhite/68" data-id="element-270" data-mp="ob0e97zlpuov">Send the PFPC team a clear description of where you are stuck.</p></div><ButtonLink href="/help/" data-id="element-271" data-mp="t80iddcw4ndc">Get Ordering Help</ButtonLink></div></section>
    </main>;
}
export { AssemblyGuidePage };